import { COLORS, FONTS } from "@constants";
import { Placement } from "popper.js";
import React from "react";
import styled from "styled-components";
import { Arrow } from "./Arrow";

interface Props {
  children: React.ReactNode;
  font?: string;
  width: string;
  color?: string;
  "data-placement": Placement;
}

/**
 * Halo-styled version of a hover tooltip for use with Tippy.
 */
export const TooltipContent: React.FC<Props> = (props) => {
  const { children, font = FONTS.REGULAR_2, width } = props;
  const color = props.color ?? COLORS.BLACK;
  const dataPlacement = props["data-placement"];

  return (
    <Container width={width} font={font}>
      {dataPlacement?.startsWith("bottom") && <Arrow color={color} direction="top" />}
      {dataPlacement?.startsWith("left") && <Arrow color={color} direction="right" />}
      <InnerContainer>{children}</InnerContainer>
      {dataPlacement?.startsWith("top") && <Arrow color={color} direction="bottom" />}
      {dataPlacement?.startsWith("right") && <Arrow color={color} direction="left" />}
    </Container>
  );
};

const Container = styled.div`
  flex-direction: column;
  align-items: center;
  background-color: ${COLORS.BLACK};
  color: ${COLORS.WHITE};
  border-radius: 6px;
  text-align: left;
  width: ${(props) => props.width ?? "auto"};
  ${(props) => props.font};
`;

const InnerContainer = styled.div`
  padding: 12px;
`;
